import React, { Component } from 'react';
import { Layout } from 'antd';
import PropTypes from 'prop-types';

const { Content } = Layout;

class CustomContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { children } = this.props;
    return (
      <Content style={{ margin: '16px 16px 0' }}>
        <div style={{ padding: 16, background: '#fff', minHeight: 20 }}>
          {children}
        </div>
      </Content>
    );
  }
}

CustomContent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.object,
};

export default CustomContent;
